import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.header`
  display: flex;
  flex: grow: 1;
`;

export const H1 = styled.h1`
  font-weight: 500;
  font-size: 2em;
`;

export const Container = styled.section`
  display: flex;
  flex-grow: 1;
  width: 500px;
  flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/styles.ts